// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3fa1d7a9","160":"c4264402","208":"93fcef8e","293":"974fd9d2","488":"554d8740","516":"9ebbdb81","519":"1862aa25","917":"26b95fd1","946":"e22463d3"}[chunkId] + ".chunk.js";
};